var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriver2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.19 2.5H7.82001C4.18001 2.5 2.01001 4.67 2.01001 8.31V16.68C2.01001 20.32 4.18001 22.49 7.82001 22.49H16.19C19.83 22.49 22 20.32 22 16.68V8.31C22 4.67 19.83 2.5 16.19 2.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.5C5.59 9.5 5.25 9.16 5.25 8.75V6.75C5.25 6.34 5.59 6 6 6C6.41 6 6.75 6.34 6.75 6.75V8.75C6.75 9.16 6.41 9.5 6 9.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.5C9.59 9.5 9.25 9.16 9.25 8.75V6.75C9.25 6.34 9.59 6 10 6C10.41 6 10.75 6.34 10.75 6.75V8.75C10.75 9.16 10.41 9.5 10 9.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 19.25C5.59 19.25 5.25 18.91 5.25 18.5V16.5C5.25 16.09 5.59 15.75 6 15.75C6.41 15.75 6.75 16.09 6.75 16.5V18.5C6.75 18.91 6.41 19.25 6 19.25Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 19.25C9.59 19.25 9.25 18.91 9.25 18.5V16.5C9.25 16.09 9.59 15.75 10 15.75C10.41 15.75 10.75 16.09 10.75 16.5V18.5C10.75 18.91 10.41 19.25 10 19.25Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8.5H14C13.59 8.5 13.25 8.16 13.25 7.75C13.25 7.34 13.59 7 14 7H18C18.41 7 18.75 7.34 18.75 7.75C18.75 8.16 18.41 8.5 18 8.5Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18.25H14C13.59 18.25 13.25 17.91 13.25 17.5C13.25 17.09 13.59 16.75 14 16.75H18C18.41 16.75 18.75 17.09 18.75 17.5C18.75 17.91 18.41 18.25 18 18.25Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11.75H2V13.25H22V11.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriver2);
export default __webpack_public_path__ + "static/media/driver-2.56dd3e5a449fad36ac77032bba6a6d27.svg";
export { ForwardRef as ReactComponent };